module.exports = __webpack_public_path__ + "static/illustration-about-1-9f73144bed703dbc3f0066b660aa580e.svg";